<label class="text-label text-surface-500" for="income">
  Annual household income
</label>

<p-selectButton
  class="signup-select-button"
  id="income"
  [dt]="dt"
  [unselectable]="false"
  [allowEmpty]="false"
  [formControl]="control()"
  [options]="incomeOptions"
  optionLabel="label" optionValue="value"/>
